<template>
	<div>
    <div class="section section_odd pt-1 pb-1 pt-sm-2">
      <div class="container-xl mt-4">
        <h1>Reti monitoraggio rischi</h1>
        <p>
          La Protezione Civile della Regione ha realizzato un articolato <strong>sistema di monitoraggio</strong>
          fisico in tempo reale.
        </p>
        <p class="d-none d-sm-block"> 
          Tale sistema è formato da un <strong>insieme di reti</strong> che consentono la <strong>previsione</strong>, 
          <strong>l'allerta</strong> e la <strong>gestione delle emergenze</strong> di protezione civile.
        </p>
      </div>
    </div>
    <div class="section section_even pt-1 pt-sm-2 pb-sm-1">
      <div class="container-xl mt-4">
        <h2>Rete idro-nivo-meteo<span class="d-none d-sm-inline">climatica</span></h2>
        <p class="d-none d-sm-block">La protezione civile della regione gestisce le stazioni per il monitoraggio atmosferico,
          idraulico, marino distribuite su tutto il territorio regionale.</p>
        <div class="row">
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="mappa_sensori">
              <figure class="figure">
                <img src="../assets/home_map.png" class="figure-img img-fluid border" alt="Mappa sensori">
                <figcaption class="figure-caption fs-4"><i class="bi bi-globe"></i> Mappa sensori</figcaption>
              </figure>
            </router-link>
          </div>
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="stazioni">
              <figure class="figure">
                <img src="../assets/home_st.jpg" class="figure-img img-fluid border" alt="Cerca stazioni">
                <figcaption class="figure-caption fs-4"><i class="bi bi-search"></i> Cerca stazioni</figcaption>
              </figure>
            </router-link>
          </div>
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="meteogramma">
              <figure class="figure">
                <img src="../assets/home_mg.png" class="figure-img img-fluid border" alt="Meteogramma">
                <figcaption class="figure-caption fs-4"><i class="bi bi-graph-up"></i> Meteogramma</figcaption>
              </figure>
            </router-link>
          </div>
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="webcam">
              <figure class="figure">
                <img src="../assets/home_we.jpg" class="figure-img img-fluid border" alt="Webcam">
                <figcaption class="figure-caption fs-4"><i class="bi bi-camera-video"></i> Webcam</figcaption>
              </figure>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="section section_odd pt-1 pb-1 pt-sm-2">
      <div class="container-xl mt-4">
        <h2>Radar</h2>
        <div v-if="! radarAvailable"  class="alert alert-warning" role="alert"><i class="bi bi-exclamation-triangle"></i> {{ radarNotAvailable() }}</div>
        <p class="d-none d-sm-block">La protezione civile della regione gestisce il radar meteorologico situato a Fossalon di Grado</p>
        <div class="row">
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="radar/VMI">
              <figure class="figure">
                <img src="../assets/home_vmi.png" class="figure-img img-fluid border" alt="Riflettività">
                <figcaption class="figure-caption fs-4"><i class="bi bi-rainbow"></i> Riflettività</figcaption>
              </figure>
            </router-link>
          </div>
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="radar/SRI">
              <figure class="figure">
                <img src="../assets/home_sri.png" class="figure-img img-fluid border" alt="Precipitazioni">
                <figcaption class="figure-caption fs-4"><i class="bi bi-cloud-rain"></i> Precipitazioni</figcaption>
              </figure>
            </router-link>
          </div>
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="vento">
              <figure class="figure">
                <img src="../assets/home_w.png" class="figure-img img-fluid border" alt="Vento">
                <figcaption class="figure-caption fs-4"><i class="bi bi-wind"></i> Vento</figcaption>
              </figure>
            </router-link>
          </div>
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="temporali">
              <figure class="figure">
                <img src="../assets/home_storm.png" class="figure-img img-fluid border" alt="Temporali">
                <figcaption class="figure-caption fs-4"><i class="bi bi-cloud-lightning-rain"></i> Temporali</figcaption>
              </figure>
            </router-link>
          </div>
          <div class="col-12 d-grid gap-2 mt-2 mb-2">
            <router-link to="radar" class="btn btn-outline-primary">
              Tutti i prodotti radar
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="section section_even pt-1 pb-1 pt-sm-2">
      <div class="container-xl mt-4">
        <h2>Terremoti</h2>
        <p class="d-none d-sm-block">La protezione civile della regione in convenzione con CRS-OGS e DMG-UNITS gestisce le stazioni sismiche situate sul territorio regionale.</p>
        <div class="row">
          <div class="col-md-3 col-sm-6 container-layout">
            <router-link to="terremoti">
              <figure class="figure">
                <img src="../assets/home_sism.png" class="figure-img img-fluid border" alt="Mappa eventi">
                <figcaption class="figure-caption fs-4"><i class="bi bi-soundwave"></i> Mappa eventi</figcaption>
              </figure>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="section section_odd mt-2 mb-2">
      <div class="container-xl">
        <div class="row">
          <div class="col-md-4 mt-2 mb-2">
            <div class="d-grid gap-2">
              <router-link to="licenza" class="btn btn-secondary">
                Licenza dei dati
              </router-link>
            </div>
          </div>
          <div class="col-md-4 mt-2 mb-2">
            <div class="d-grid gap-2">
              <a href="/api/apidocs/index.html" class="btn btn-secondary">
                Accesso tramite API
              </a>
            </div>
          </div>
          <div class="col-md-4 mt-2 mb-2">
            <div class="d-grid gap-2">
              <router-link to="attribuzioni" class="btn btn-secondary">
                Attribuzioni
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
	</div>
  <app-footer></app-footer>
</template>

<script>
import AppFooter from '../app-footer.vue';
import MonitorApi from '@/services/MonitorApi';
import Labels from '@/utils/labels';

export default {
  name: 'Home',
  components: { AppFooter },
  mixins: [Labels],
  data: function() {
    return {
      radarAvailable: true
    }
  },
  methods: {
    checkRadarAvailability: async function(radar_name){
      const max_time = 129600000; // 36 h
      let to = new Date;
      if(this.radar_time) {
        to = this.radar_time;
      }
      const from = new Date(to - max_time);
      let products;
      products = await MonitorApi.getRadarProducts(1, radar_name, from, to, 1);
      this.radarAvailable = products.length > 0;
    }
  },
  mounted: function(){
    this.checkRadarAvailability('VMI');
  }

}
</script>

<style scoped lang="scss">

.container-layout{
  text-align: center;
}
  .figure-caption {
    width: 100%;
    background-color: #f1f6f1;
    display: block;
    font-variant: small-caps;
    font-weight: bold;
    color: #0067b1;
  }
  .section_odd {
    .figure-caption {
      background-color: #fff;
    }
  }

</style>